export enum TransitionState{
    NotStarted = 1,
    Running = 2,
    Completed = 3,
}